import React from 'react';
import TableDataField from './TableDataField';

const CodeCategoryField = ({ codeCategory }) => {
    return <TableDataField extraStyling="col-medium">{codeCategory}</TableDataField>;
};

export default CodeCategoryField;
